/** Cinco indicadores da carteira; no celular viram carrossel com snap. */
import React from "react";
import { motion } from "framer-motion";

import { formatarReaisBR } from "../../../../utils/dinheiro";
import { NumeroAnimado, Sparkline } from "../comum/Graficos";
import { ENTRADA_DE_CARD, transicaoDeCard } from "../comum/movimento";

const COR = { accent: "var(--accent)", bad: "var(--bad)", warn: "var(--warn)", c2: "var(--c2)", ok: "var(--ok)" };
const OCULTO = "••••••";

function Valor({ indicador, precosVisiveis }) {
  if (indicador.dinheiro && !precosVisiveis) return <span className="cl-kpi-n priv">{OCULTO}</span>;
  return (
    <span className="cl-kpi-n">
      <NumeroAnimado
        chave={`kpi-${indicador.id}`}
        valor={indicador.dinheiro ? Math.round(indicador.valor) : indicador.valor}
        formatar={indicador.dinheiro ? formatarReaisBR : String}
      />
    </span>
  );
}

export default function Indicadores({ indicadores, precosVisiveis }) {
  return (
    <section className="cl-kpis cl-hscroll" aria-label="Indicadores" data-pdf="indicadores">
      {indicadores.map((k, i) => (
        <motion.div
          key={k.id}
          className={`cl-kpi${k.alerta && k.valor > 0 ? " bad" : ""}`}
          style={{ "--k": COR[k.cor] }}
          initial={ENTRADA_DE_CARD.inicial}
          animate={ENTRADA_DE_CARD.final}
          transition={transicaoDeCard(i)}
        >
          <div className="cl-eyebrow">{k.rotulo}</div>
          <div className="cl-kpi-v"><Valor indicador={k} precosVisiveis={precosVisiveis} /></div>
          <div className="cl-kpi-f">
            <span className="cl-kpi-c">{k.dinheiro && !precosVisiveis ? "valores ocultos" : k.legenda}</span>
            <Sparkline serie={k.serie} rotulo={k.serieRotulo} />
          </div>
        </motion.div>
      ))}
    </section>
  );
}
